import ContentSidebar from './ContentSidebar';

export default ContentSidebar;
